import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSend = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.00309 17.9903C4 17.9962 4 18.0002 4 18.0002L20 11.9952L4.00309 6.00018L6.4947 11.6046C6.6058 11.8544 6.6058 12.137 6.4947 12.3858L4.00309 17.9903ZM4.04527 20.0002C3.50209 20.0002 2.97016 19.7885 2.57632 19.3928C2.00143 18.8163 1.84083 17.9654 2.16612 17.2278H2.16715L4.47286 11.9992L2.16715 6.77159C1.84083 6.03302 2.00143 5.18312 2.57632 4.60658C3.15122 4.02905 4.02072 3.84615 4.78895 4.13541L20.6947 10.1463C21.4885 10.4455 22 11.1732 22 11.9992C22 12.8252 21.4885 13.5529 20.6947 13.8521L4.78895 19.864C4.54652 19.9555 4.29487 20.0002 4.04527 20.0002V20.0002Z",
		fill: "currentColor"
	})
});
export default SvgIconSend;
